import { render, staticRenderFns } from "./galleryVideo.vue?vue&type=template&id=301fb153&"
import script from "./galleryVideo.vue?vue&type=script&lang=js&"
export * from "./galleryVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QVideo,QBtnGroup,QPagination,QDialog,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QVideo,QBtnGroup,QPagination,QDialog,QCardActions}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
